import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { RegistrationService } from '../../services/registration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
  FormControlDirective,
  FormControlName
} from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-academic-information',
  templateUrl: './academic-information.component.html',
  styleUrls: ['./academic-information.component.scss']
})
export class AcademicInformationComponent implements OnInit {
  msgs: Message[] = [];
  msgserror: Message[] = [];
  msgMarksEntry: Message[] = [];
  msgInstDetails: Message[] = [];
  alertMsg: Message[] = [];
  activeIndex = 1;

  studentAcademicRecords: any[];
  cols: any[];

  marksEntryDialogDisplay: boolean;
  instDetailsDialogDisplay: boolean;

  academicForm: FormGroup;

  dataList: any;
  isOtherInst: boolean = true;
  isOtherState: boolean = true;
  isOtherCity: boolean = true;
  otherOption: boolean = false;
  isPrevUniv: boolean = false;
  isPrevUnivSingle: boolean = false;
  countryId: any;
  stateId: any;
  data: any;
  newRow: any;
  token: any;
  isCuRegCourseTypePrevColg: boolean = false;
  // isCuRegCourseTypePrevColgSingle: boolean = false;
  isError: boolean = false;
  showclose = false;

  public boardList = [];
  public degreeList = [];
  public englishSubjects = [];
  public nonEnglishSubjects = [];

  public englishSubjectsHidden = [];
  public nonEnglishSubjectsHidden = [];

  public lastInstituteList = [];
  public allcountrylist = [];
  public stateList = [];
  public cityList = [];
  public instMediumList = [];
  public passingYearList = [];
  public prvcourseTypeList = [];
  public prevCollegeList = [];
  public prevstreamList = [];
  public patchList = [];
  public gradeList = [];
  public levelList = [];
  public statusList = [];
  public genericList = [];
  totalMarks: any;
  theoryFullMarks: any;
  practicalFullMarks: any;
  theoryPassMarks: any;
  practicalPassMarks: any;
  paperType: any;
  type: boolean = false;
  disablePracticalMarks: boolean = false;
  disablePassInst: boolean = true;
  patchData: boolean = false;
  disablesubmit = false;
  disableBoard: boolean = false;
  crsselct: any;
  resdata: any;
  // @ViewChild('fullMarks') inputs : ElementRef;
  // @ViewChild('obtainmarks') inputmarks : ElementRef;
  doneButton: boolean = true;

  boardid: any;
  boarrollnoforotherboard = false;
  labelName: any = 'Roll No';
  alphaNumeric = "^[a-zA-Z0-9]*$";
  onlyNumeric = "^[0-9]*$";

  arrayTest = [];
  isOtherUniversity: boolean = true;
  semNotClearedDisplay: boolean = false;
  displayModal: boolean = false;
  // openInstitutedetails: boolean = false;
  instituteDialogBox: boolean = false;
  semesterEntry: boolean = false;

  constructor(
    private registrationService: RegistrationService,
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
  }

  ngOnInit() {
    this.spinner.show();
    this.alertMsg = [];
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Please Note :' });
    this.msgs.push({
      severity: 'info',
      detail:
        '1.<strong> Students having fail paper(s) in Semester VI or previous semesters are not allowed to apply as per Calcutta University Norms.</strong>'
    });
    this.msgs.push({
      severity: 'info',
      summary:
        '<strong><font color="red">2. Only applicants who have completed a 3-year Honours/Major degree and graduated in 2022 or later are eligible to apply for the Postgraduate programmes.</font></strong>'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '<strong><font color="blue">3.  Applicants who have graduated with General Course are not eligible to apply for Post Graduation course as per Calcutta University norms. </font></strong>'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '4. <strong> For M. Com only Accounts & Finance and Marketing Specialisations are offered.</strong>'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '5. <strong> Applicants who have studied Taxation or E-Business as their specialization in their graduation can apply for M. Com opting for either of the offered specializations as mentioned in serial no. 4 above.</strong>'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '6. It is mandatory for Merit-listed students to provide the original copy of the Semester VI Marksheet at the time of document verification or when asked by the College.'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '7. Once University / Marks & Institute details are filled up, please click on Submit button to save and continue for course selection.'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '8. <strong><font color="red">Red dot</font></strong> indicates mandatory field.'
    });

    this.msgMarksEntry = [];
    this.msgMarksEntry.push({ severity: 'info', summary: 'Please Note :' });
    this.msgMarksEntry.push({
      severity: 'info',
      detail: 'i. Fill-up your semester wise SGPA’s exactly as per your marksheet(s) as it will be considered for calculation of CGPA.'
    });
    this.msgMarksEntry.push({
      severity: 'info',
      detail:
        'ii. In case your University has not issued the Semester VI Original Marksheet yet, you can proceed with your application by entering the SGPA as given in your Semester VI Digital Marksheet / Online Result.'
    });
    this.autoLogin();
    this.msgInstDetails = [];
    this.msgInstDetails.push({ severity: 'info', summary: 'Please Note :' });
    this.msgInstDetails.push({
      severity: 'info',
      detail:
        "1. Please select your college's name under the “Last Institute Name” option in serial no. B(ii). In case your college’s name is not enlisted in the dropdown list, select “Other Institute” from the list and enter the name of your college in serial no. B (iii)."
    });
    this.msgInstDetails.push({
      severity: 'info',
      detail:
        '2. <strong><font color="red">Red dot</font></strong> indicates mandatory field.'
    });

    if (localStorage.getItem('meritlisted') === "yes") {
      this.disablesubmit = true;
    }

    this.studentAcademicRecords = [
      {
        graduation: 'B.Tech',
        university: 'Jadavpur University',
        subjectMarks: 'Math: 85, Physics: 90',
        instituteDetails: 'Kolkata Campus'
      }
    ];

    this.cols = [
      { field: 'graduate', header: 'Graduated With' },
      { field: 'university', header: 'University' },
      { field: 'marks', header: 'Subjectwise Marks' },
      { field: 'insDtls', header: 'Institute Details' }
    ];
    this.statusList = [
      {
        'id': 'Semester Cleared',
        'name': 'Semester Cleared'
      },
      {
        'id': 'Semester Not Cleared',
        'name': 'Semester Not Cleared'
      },
    ]
    this.registrationService
      .getAcademicList(localStorage.getItem('authToken'))
      .then(commonList => {
        console.log(commonList);
        this.dataList = commonList;
        this.boardList = commonList.boardlist;
        this.degreeList = this.dataList.degreeList;
        this.lastInstituteList = this.dataList.LastInstListforXI;
        this.allcountrylist = this.dataList.allcountrylist;
        this.instMediumList = this.dataList.instMediumList;
        this.passingYearList = this.dataList.yearOfPassing;
        this.prvcourseTypeList = this.dataList.prvcourseTypeList;
        this.prevCollegeList = this.dataList.PrvInstListforGRD;
        this.gradeList = this.dataList.gradelist;
        this.levelList = this.dataList.levellist
        this.spinner.hide();
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
    this.academicForm = this.fb.group({
      boardId: [null, Validators.required],
      //new field
      id: [null],
      parent_id: [null],
      subjectDetailInfo: this.fb.array([]),
      // add by JD
      degreeId: [null, Validators.required],
      rollNo: new FormControl('', [Validators.required]),
      regno: new FormControl('', [Validators.required]),
      otherBoardName: [null],
      lastschoolId: [null, Validators.required],
      lastschoolName: [null],
      yearofPassing: ['2026', Validators.required],
      mediumofInstruction: ['1', Validators.required],
      // end by JD
    });
    if (localStorage.getItem('step') == '') {
      this.showclose = true;
    }
  }

  patchForm() {
    this.token = JSON.parse(localStorage.getItem('userDetails'));
    this.token = '';
    this.token = JSON.parse(localStorage.getItem('userDetails'));
    if (this.token.academicDetailInfo[0] != undefined) {
      if (this.token.academicDetailInfo[0].degreeId != null) {
        this.disablePassInst = false;
        this.patchData = true;
      }
      else {
        this.disablePassInst = true;
      }
      if (this.dataList.courseSelection == 'yes') {
        this.academicForm.get('degreeId').disable();
        this.disablePassInst = false;
      }
      this.academicForm.patchValue(this.token.academicDetailInfo[0]);
      this.setMarks();
    }

  }
  setMarks() {
    this.spinner.show();
    let token = localStorage.getItem('authToken');
    let control = <FormArray>this.academicForm.controls.subjectDetailInfo;
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    // ----------------- add by JD ---------------
    this.token.academicDetailInfo[0].subjectDetailInfo.forEach((x, index) => {
      control.push(
        this.fb.group({
          gradeid: index,
          obtainmarks: x.obtainmarks,
          status: x.status,
        })
      );
    });
  }

  showMarksEntryDialog() {
    if (this.academicForm.value.boardId == null) {
      this.alertMsg = [];
      this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: 'Please select Board' });
      return false;
    }
    const arr = <FormArray>this.academicForm.controls['subjectDetailInfo'];
    //arr.controls = [];
    this.marksEntryDialogDisplay = true;
    if (arr.length == 0) {
      for (let i = 1; i <= 6; i++) {
        this.addMarks();
      }
    }
  }

  // Add by JD
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  donemarksEntry() {                             //Add by JD
    // console.log(this.academicForm.value.subjectDetailInfo);
    // this.openInstitutedetails = true;
    const control = this.academicForm.value.subjectDetailInfo;
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    for (let i = 0; i < control.length; i++) {
      if (control[i].obtainmarks > 100 || control[i].obtainmarks <= 0) {
        controlArray.controls[i].get('obtainmarks').setValue('');
        this.msgserror = [];
        this.msgserror.push({
          severity: 'error',
          summary: 'Please enter valid marks at row no.' + (1 + i) + '.'
        });
        return false;
      } else if (control[i].status < 1) {
        controlArray.controls[i].get('status').setValue('');
        this.msgserror = [];
        this.msgserror.push({
          severity: 'error',
          summary: 'Please enter Result Status at row no.' + (1 + i) + '.'
        });
        return false;
      }
    }
    this.marksEntryDialogDisplay = false;
    this.semesterEntry = true;
  }

  semNotCleared(index, e) {
    const control = this.academicForm.value.subjectDetailInfo;
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    if (e.target.value == "Semester Not Cleared") {
      controlArray.controls[index].get('status').setValue('');
      this.msgserror = [];
      this.msgserror.push({
        severity: 'error',
        summary: 'Applicant having fail paper(s) in any semester are not allowed to apply as per Calcutta University Norms.'
      });
      return false;
    }
  }

  checkRepeat(i, e) {
    const p = e.target.value;
    let marksdata = [];
    marksdata = this.academicForm.value.subjectDetailInfo;
    for (let n = 0; n < marksdata.length; n++) {
      if (n !== i) {
        if (marksdata[n].paperName == p) {
          e.target.value = 0;
          return false;
        }
      }
    }
  }

  addMarks() {
    const control = <FormArray>this.academicForm.controls['subjectDetailInfo'];
    let newMarksGroup: FormGroup = this.initItems();
    control.push(newMarksGroup);
  }

  // -------------------- Add by JD ---------
  initItems(): FormGroup {
    return this.fb.group({
      obtainmarks: ['', Validators.required],
      status: ['0', Validators.required]
    });
  }

  removeMarks(index, id) {
    const control = <FormArray>this.academicForm.controls['subjectDetailInfo'];
    control.removeAt(index);
    if (id != undefined) {
      this.registrationService.deleteRowByMarksId(id).subscribe(data => {
        alert('successfully deleted');
      });
    }
  }

  getStateCity(x, y, z) {
    this.countryId = x;
    this.stateId = y;
    if (x == 1) {
      this.otherOption = false;
    } else {
      this.otherOption = true;
    }
    this.registrationService.getStateCity(x, y, z).subscribe(data => {
      this.stateList = [];
      this.cityList = [];
      this.dataList = data;
      this.stateList = this.dataList.stateList;
      this.cityList = this.dataList.cityList;
    });
  }
  //add by jd
  enableOtherInst() {
    const lastschoolName = this.academicForm.get('lastschoolName');
    if (this.academicForm.value.lastschoolId == '-1') {
      this.isOtherInst = false;
      lastschoolName.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.lastschoolName.setValue(null);
      this.isOtherInst = true;
      lastschoolName.clearValidators();
    }
    lastschoolName.updateValueAndValidity();
  }

  enableOtherState() {
    const otherSchoolState = this.academicForm.get('otherSchoolState');
    if (this.academicForm.value.stateId == '-1') {
      this.isOtherState = false;
      otherSchoolState.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.otherSchoolState.setValue(null);
      this.isOtherState = true;
      otherSchoolState.clearValidators();
    }
    otherSchoolState.updateValueAndValidity();
  }

  enableOtherCity() {
    const otherSchoolCity = this.academicForm.get('otherSchoolCity');
    if (this.academicForm.value.schoolcityId == '-1') {
      this.isOtherCity = false;
      otherSchoolCity.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.otherSchoolCity.setValue(null);
      this.isOtherCity = true;
      otherSchoolCity.clearValidators();
    }
    otherSchoolCity.updateValueAndValidity();
  }

  // ---------------------- Add by JD -------------------------
  selectOtherUniversity() {
    const otherBoardName = this.academicForm.get('otherBoardName');
    if (this.academicForm.value.boardId == 13) {
      this.isOtherUniversity = false;
      otherBoardName.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.otherBoardName.setValue(null);
      this.isOtherUniversity = true;
      otherBoardName.clearValidators();
    }
    otherBoardName.updateValueAndValidity();

  }



  showInstDetailsDialog() {
    if (this.academicForm.value.boardId == null) {
      this.spinner.hide();
      this.alertMsg = [];
      this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: 'Please select Board' });
      return false;
    }
    this.instDetailsDialogDisplay = true;
  }


  doneInstituteDetails() {
    if (this.academicForm.valid) {
      this.instDetailsDialogDisplay = false;
      this.instituteDialogBox = true;
    } else {
      alert("Please Enter All Details");
    }
  }

  saveAcademicdetails() {
    if (this.patchData == false) {
      if (this.academicForm.value.boardId != null && this.academicForm.value.degreeId != null && this.semesterEntry == false && this.instituteDialogBox == false) {
        this.alertMsg.push({
          severity: 'error',
          summary: 'Please enter SemesterWise Marks.'
        });
        setTimeout(() => {
          this.alertMsg.shift(); // or this.alertMsg.splice(0, 1); to remove the first item
        }, 3000);
        return false;
      }
      if (this.academicForm.value.boardId != null && this.academicForm.value.degreeId != null && this.instituteDialogBox == false) {
        this.alertMsg.push({
          severity: 'error',
          summary: 'Please enter Institute Details.'
        });
        setTimeout(() => {
          this.alertMsg.shift(); // or this.alertMsg.splice(0, 1); to remove the first item
        }, 3000);
        return false;
      }
    }
    // console.log(this.academicForm.value)
    if (this.academicForm.valid) {
      console.log("submit after valid");
      let token = localStorage.getItem('authToken');
      const control = this.academicForm.value.subjectDetailInfo;
      if (control.length < 6) {
        this.alertMsg.push({
          severity: 'error',
          summary: 'Please enter all Semesterwise Marks.'
        });
        return false;
      }
      this.spinner.show();
      this.academicForm.get('degreeId').enable();
      // this.academicForm.value.degreeId = 2;
      this.data = {
        academicDetailInfo: [this.academicForm.value]
      };
      // console.log(this.data);
      this.registrationService.saveAcademicDetails(token, this.data).subscribe(data => {
        this.spinner.hide();
        this.resdata = data;
        if (this.resdata.status == 'success') {
          alert('Academic data saved.');
          this.router.navigate(['admission/course-information']);
          if (localStorage.getItem('step') !== '') {
            this.router.navigate(['admission/course-information']);
          } else {
            this.router.navigate(['admission/course-information']);
          }
        }
        else {
          alert(this.resdata.massege);
        }
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
    } else {
      const control = this.academicForm.value.subjectDetailInfo;
      Object.keys(this.academicForm.controls).forEach(control => {
        this.academicForm.controls[control].markAsDirty();
      });
    }
  }
  autoLogin() {
    this.registrationService
      .loginByToken(localStorage.getItem('authToken'))
      .subscribe(
        data => {
          //console.log(data);
          this.dataList = data;
          this.crsselct = this.dataList.courseSelection;
          localStorage.setItem('authToken', this.dataList.authToken);
          localStorage.setItem(
            'userDetails',
            JSON.stringify(this.dataList.userDetails)
          );
          localStorage.setItem('step', this.dataList.step);
          this.patchForm();
        },
        err => console.log(err),
        () => console.log('Request Completed')
      );
  }
  checkRegNo() {
    if (localStorage.getItem("admin") != 'yes') {
      if (this.academicForm.controls.regno.dirty) {
        this.registrationService.checkregNumber(this.academicForm.value.regno).subscribe(data => {
          this.dataList = data;
          if (this.dataList.status == "success") {
            this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: "Board Roll No Already Exists." });
            this.academicForm.controls.regno.setValue(null);
          }
        }, err => {
          ///alert("Something went wrong, Please try again.")
          this.spinner.hide();
        })
      }
    }

  }

  closemarksEntry() {
    this.marksEntryDialogDisplay = false;
  }

  closeInstDtls() {
    this.instDetailsDialogDisplay = false;
  }

  enableMarksInstEntry(e) {
    // console.log(e.target.value)
    if (e.target.value != null) {
      this.disablePassInst = false;
    }
  }

  //avoidSpace on board roll no
  avoidSpace(event) {
    let k = event.keyCode;
    if (k == 32) return false;
  }

  goToDashboard() {
    this.router.navigate(['candidate/dashboard']);
  }

  onFloatClick() {
    window.open("https://app.botbaba.io/bot/1158ALGR6Xj/BESC%20QBOT");
  }

  partOrCbseSelection() {
    const val = this.academicForm.controls['prevuniexam'].value;
    // console.log(val);
    if (val === 'Part-system') {
      this.doneButton = false;
      alert('As per Calcutta University regulations, you are not eligible to apply for any courses. Please read the Eligibility Criteria available on the College website for same.')
      this.router.navigate(['admission/academic-information']);
    } else {
      this.doneButton = true;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/admission/academic-information/academic-information.component.ts